import { w3cwebsocket } from 'websocket';

import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

const useSendReaction = (ws: React.MutableRefObject<w3cwebsocket | null>) => {
  const { widget } = useWidgetContext();

  const sendReaction: Env.SendReaction = async (id: string, content: string) =>
    ws.current?.send(
      JSON.stringify([
        'message',
        { chat_id: widget.instance_chat_key, content, id, type: 'reactions' },
      ]),
    );

  return sendReaction;
};

export default useSendReaction;
